define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/view/PdfRequestController"
], function(declare,locale,MessageDialog,PdfRequestController) {

	return declare(PdfRequestController, {


		onCreatePopup: function(/*csi.view.Widget*/view) {
			this.inherited(arguments);
			view.addDefaultValue("RefreshDataSheets", true);
			const srLocale = this.m_cache.getNode(this.getParent().Locale);
			const fd = this.getFormData();
			if(srLocale && fd) {
				fd.setFieldInitialValue("Locale", srLocale.$Name);
			}
		},

		postProcessSuccess: function() {
			// refresh data sheets view if necessary
			const b = this.m_formData.getFieldValue("RefreshDataSheets");
			if (b) {
				var	view = this.widget.viewParent.getChildView("DataSheets");
				if (view) {
					view.refreshWidget(true);
				}
			}

			this.inherited(arguments);
		}
	});
});